<script>

import utils from "../../utils";

export default {
    mounted() {
        document.getElementsByTagName("html")[0].classList.add('main-with-background');
    },
    destroyed() {
        utils.removeBackground();
    }
}
</script>
<style scoped>
@media (max-width: 736px) {

    .form-container {
        top: 10px !important;
        left: 10px !important;
        width: 100% !important;
    }

    .wrapper {
        width: 100% !important;
        background: rgba(0, 0, 0, 0.0) !important;
    }

    .left {
        display: none;
    }

    .margin-bottom-10 {
        margin-bottom: 10%;
    }
}

.padding-top-50px {
    padding-top: 50px;
}

.height-50px {
    height: 50px;
}

.meu-container {
    background: url(./backgroundSGS.jpg);
    width: 100%;
    display: block;
    min-height: 100%;
    background-size: cover;
}

.wrapper {
    background: rgba(0, 0, 0, 0.8);
    position: relative;
    width: 800px;
    min-height: 300px;
    margin: 0 auto;
    margin-top: 10%;
}

.left,
.right {
    width: 50%;
}

.left {
    float: left;
}

.right {
    float: right
}

.back-header,
.back-p {
    margin: 20px;
    color: #fafafa;
}

.back-header {
    font-family: 'Ubuntu';
    font-size: 30px;
    font-weight: 500;
}

.back-p {
    font-size: 17px;
}

.login {
    margin: 40px;
}

.form-btn {
    width: 125px;
    height: 35px;
    font-size: 18px;
    border: 0;
    border-radius: 3px;
    background-color: #ff6600;
    color: #fafafa;
    transition: .4s all;
}

.login button:hover {
    background-color: #C53716;
}

.form-header {
    font-size: 32px;
    color: #ff6600;
}

.form-container input {
    margin-top: 20px;
    height: 30px;
    border: 0;
    border-bottom: 1px solid #888;
    box-shadow: none;
}

.form-container input:focus {
    border: 0;
    border-bottom: 1px solid #ff6600;
}

input[type="text"],
input[type="email"] {
    color: #555;
}

.img {
    padding: 16px 78px 0px;
    height: 68px;
}

.input-group-addon {
    padding: 25px 10px 25px 0 !important;
    background-color: #fff !important;
    border: none !important;
}

.form-group {
    margin-bottom: 0;
}

.alert {
    margin-bottom: 10px;
}

.min-height {
    min-height: 30px;
}

.form-container {
    min-height: 350px;
    position: absolute;
    width: 375px;
    background-color: white;
    top: -25px;
    right: 10px;
    box-shadow: 9px 13px 16px 0px rgba(0, 0, 0, 0.75);
}

</style>

<template>
    <div class="meu-container">
        <div class="row margin-bottom-10" style="width: 100%;">

            <div class="col-md-12">
                <div class="wrapper">
                    <div>
                        <div class="left">
                            <div>
                                <img src="./logo-NOW_6.png" alt="SGS DO BRASIL" class="img">
                            </div>
                            <p class="back-p">
                                {{ $t('loginDescription') }}
                            </p>
                        </div>
                    </div>
                    <div class="form-container">
                        <slot></slot>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>




// WEBPACK FOOTER //
// LoginTemplate.vue?7d959d61